import commonServices from '@/common/services/services'

export const viewsModes = {
  merchant: 'merchant',
  store: 'store',
}

export const servicesByViewsMode = {
  [viewsModes.merchant]: {
    getViews: params => commonServices.getMerchantViews(params),
    createView: params => commonServices.createMerchantView(params),
    deleteView: params => commonServices.deleteMerchantView(params),
    saveView: params => commonServices.saveMerchantView(params),
  },
  [viewsModes.store]: {
    getViews: params => commonServices.getViews(params),
    createView: params => commonServices.createView(params),
    deleteView: params => commonServices.deleteView(params),
    saveView: params => commonServices.saveView(params),
  },
}
